{
  "name": "drift",
  "doc": "No zoom, a lateral drift and a gentle noise warp: the history slides across the frame like weather. The calm preset of the library.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.002,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0.0035,
  "dy": 0.0012,
  "sx": 1,
  "sy": 1,
  "warp": 0.006,
  "warpScale": 2.5,
  "warpSpeed": 0.25,
  "decay": 0.958,
  "invert": 0,
  "hueShift": 0.002,
  "darkenCenter": 0.0,
  "wave": "MIRROR",
  "waveColor": 1,
  "shapes": 0,
  "energy": [
    0.0,
    0.5
  ]
}